import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';

import {
    clearOpenRepairConflicts,
    submitBlockedResultsWithOverride
} from '../../actions/measurementPointResultsActions';
import { getOpenRepairConflicts } from '../../reducers/openRepairConflictsReducer';
import { OpenRepairBlockInfo } from './OpenRepairBlockInfo';

/**
 * Surfaces the open repair block for answers the API rejected during a background sync, where the
 * Save & Log pre-check could not run because the device was offline at the time. Headless: mounted
 * once at the app root so the block is seen wherever the user has navigated to.
 */
export const OpenRepairConflictWatcher = () => {
    const { t } = useTranslation('measurementPoints');
    const dispatch = useDispatch();
    const { conflicts } = useSelector(getOpenRepairConflicts);

    useEffect(() => {
        if (!conflicts.length) {
            return;
        }

        const jobNumbers = conflicts.map(conflict => conflict.jobNumber).join(', ');

        toastr.confirm(t('measurementPoints:openRepairBlockSync', { jobNumber: jobNumbers }), {
            // ESC and Enter both resolve to onOk, so the override stays click-only
            disableCancel: true,
            component: OpenRepairBlockInfo,
            okText: t('common:ok'),
            onOk: () => dispatch(clearOpenRepairConflicts()),
            buttons: [
                {
                    text: t('measurementPoints:overrideOpenRepairBlock'),
                    handler: () => dispatch(submitBlockedResultsWithOverride())
                },
                { ok: true }
            ]
        });
    }, [conflicts, dispatch, t]);

    return null;
};

export default OpenRepairConflictWatcher;
